const updates = [
  { time: '10 分钟前', title: '某女星发文暗示将有大动作，粉丝猜测新剧官宣在即', tag: '最新', tagStyle: 'bg-primary-500 text-background-50' },
  { time: '28 分钟前', title: '网传某档音乐综艺将空降神秘嘉宾，节目组未回应', tag: '热点', tagStyle: 'bg-accent-500 text-background-50' },
  { time: '1 小时前', title: '某男团成员被拍到独自现身医院，经纪公司称例行体检', tag: '快讯', tagStyle: 'bg-secondary-500 text-background-50' },
  { time: '2 小时前', title: '知名编剧发长文回应剧本争议，直言行业乱象令人心寒', tag: '跟进', tagStyle: 'bg-secondary-400 text-background-50' },
  { time: '3 小时前', title: '某平台年度盛典官宣首批嘉宾阵容，顶流云集引期待', tag: '官宣', tagStyle: 'bg-background-300 text-foreground-700' },
  { time: '5 小时前', title: '网友偶遇某知名导演携新作秘密试映，口碑极佳', tag: '路透', tagStyle: 'bg-background-300 text-foreground-700' },
  { time: '7 小时前', title: '某歌手因身体原因取消本周演出，歌迷纷纷表示理解', tag: '公告', tagStyle: 'bg-background-300 text-foreground-700' },
  { time: '9 小时前', title: '有人爆料某综艺节目剪辑存在恶意引导，制片人出面澄清', tag: '辟谣', tagStyle: 'bg-background-300 text-foreground-700' },
  { time: '12 小时前', title: '某国际电影节公布入围名单，三部华语片成功入围主竞赛', tag: '喜讯', tagStyle: 'bg-background-300 text-foreground-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            最新快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">实时滚动更新，吃瓜快人一步</p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-5 top-0 bottom-0 w-px bg-background-200"></div>
          <div className="space-y-5">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-4 pl-12">
                <div className="absolute left-3.5 top-2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex-1 min-w-0 bg-background-100 rounded-xl p-4 hover:bg-background-200/70 transition-colors cursor-pointer">
                  <div className="flex items-center gap-3 mb-1.5 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${item.tagStyle}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}